import { render } from "./RiSetting.vue?vue&type=template&id=33960813"
import script from "./RiSetting.vue?vue&type=script&lang=js"
export * from "./RiSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33960813"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33960813', __exports__)) {
    api.reload('33960813', __exports__)
  }
  
  module.hot.accept("./RiSetting.vue?vue&type=template&id=33960813", () => {
    api.rerender('33960813', render)
  })

}


export default __exports__